module.exports = __webpack_public_path__ + "img/2.e1e85f89.png";